import { IContractCancellationsRepository } from 'modules/customer/domain/repositories';

export class FetchOpenContractCancellationUseCase {
  constructor(
    private contractCancellationsRepository: IContractCancellationsRepository,
  ) {}

  public async execute() {
    return this.contractCancellationsRepository.findOpen();
  }
}
